import React from "react";
import {
  Card,
  CardActions,
  CardTitle,
  CardText
} from "material-ui/Card";
import NewPasswordForm from "../components/NewPasswordForm";
import Login from "../components/Login";
import RegistrationForm from "../components/RegistrationForm";
import RaisedButton from "material-ui/RaisedButton";
import { connect } from "react-redux";
import {
  resetPassword,
  signIn,
  completeNewPasswordChallenge,
  register,
  resetAuthErrors,
  forgotPassword
} from "../actions/auth";
import { Link } from "react-router";
import TosDialog from '../components/TosDialog';

class Introduction extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loginOpen: false,
      registrationOpen: false,
      tosOpen: false,
      attrs: {}
    };
  }

  render() {
    let props = this.props;
    return (
      <Card style={{ maxWidth: 800, margin: "0 auto" }}>
        <CardTitle title="Welcome to the FishPath Tool!" />
        <CardText>
          The FishPath Tool is an online decision-support tool for data-limited fisheries management.
          The primary goal of the FishPath Tool is to support users in understanding and refining options
          for the three major components of a harvest strategy: 1) data collection, 2) data-limited assessment,
          and 3) management measures. Once registered, you may access the FishPath Tool, including the FishPath
          questionnaire, interactive results tailored to your fishery, and supporting resources.
        </CardText>
        <Login
          onForgotPassword={this.props.forgotPassword}
          error={this.props.authError}
          open={this.state.loginOpen}
          onRequestClose={this.closeLogin}
          onSubmit={this.props.signIn}
          submitting={this.props.fetchingAuth}
          inForgotPasswordFlow={this.props.inForgotPasswordFlow}
          handleForgotPasswordCode={this.props.handleForgotPasswordCode}
        />
        <RegistrationForm
          error={this.props.authError}
          open={this.state.registrationOpen}
          onRequestClose={this.closeLogin}
          onSubmit={this.onRegistrationSubmit}
          errors={this.props.registrationErrors}
          submitting={this.props.fetchingAuth}
        />
        { this.state.tosOpen && <TosDialog open={true} onAccept={this.onAcceptTos} onReject={() => this.setState({tosOpen: false})} />}
        <NewPasswordForm
          open={this.props.newPasswordRequired}
          onSubmit={this.props.provideNewPassword}
        />
        {!props.signedIn ? (
          <CardActions style={{ textAlign: "center" }}>
            <RaisedButton
              primary={true}
              label="Create an Account"
              onClick={this.openRegistration}
            />
            <RaisedButton label="Login" onClick={this.openLogin} />
          </CardActions>
        ) : (
          <CardActions style={{ textAlign: "center", paddingBottom: 30 }}>
            <RaisedButton
              primary={true}
              label="View My Fisheries List"
              containerElement={<Link to="/home" />}
            />
          </CardActions>
        )}
      </Card>
    );
  }

  openLogin = () => {
    this.setState({ loginOpen: true });
  };

  openRegistration = () => {
    this.setState({ registrationOpen: true });
  };

  closeLogin = () => {
    this.props.resetAuthErrors();
    this.setState({
      loginOpen: false,
      registrationOpen: false
    });
  };

  onRegistrationSubmit = attrs => {
    this.setState({attrs: attrs, tosOpen: true});
  };

  onAcceptTos = () => {
    this.setState({tosOpen: false});
    this.props.register(this.state.attrs, () => {
      this.setState({ registrationOpen: false });
    });
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    fetchingAuth: state.auth.fetching,
    newPasswordRequired: !!state.auth.newPasswordRequired,
    userAttributes: state.auth.newPasswordUserAttributes,
    registrationErrors: state.auth.registrationErrors,
    authError: state.auth.error,
    inForgotPasswordFlow: state.auth.forgotPasswordCodeSent,
    signedIn: !!state.auth.email
  };
};

const mapDispatchToProps = dispatch => {
  return {
    signIn: creds =>
      dispatch(
        signIn(creds.email, creds.password, () => (window.location = "/home"))
      ),
    provideNewPassword: password =>
      dispatch(completeNewPasswordChallenge(password)),
    // register: (attributes) => dispatch(register(attributes, () => window.location = "/home")),
    register: (attributes, callback) =>
      dispatch(register(attributes, callback)),
    resetAuthErrors: () => dispatch(resetAuthErrors()),
    forgotPassword: email => dispatch(forgotPassword(email)),
    handleForgotPasswordCode: (code, password) =>
      dispatch(resetPassword(code, password))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Introduction);
